import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    eventName: String,
    eventProperties: String,
    parentSelector: String,
  };

  get targetableAncestor() {
    if (this.hasParentSelector) {
      return this.element.closest(this.parentSelector);
    }
    return this.element.parentElement;
  }

  get properties() {
    return JSON.parse(this.eventPropertiesValue);
  }

  initialize() {
    this.onClick = this.onClick.bind(this);
  }

  connect() {
    this.targetableAncestor.addEventListener('click', this.onClick);
  }

  disconnect() {
    this.targetableAncestor.removeEventListener('click', this.onClick);
  }

  onClick() {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.group(`Analytics Tracking Event: ${this.eventNameValue}`);
      // eslint-disable-next-line no-console
      console.log(`properties: ${this.eventPropertiesValue}`);
      // eslint-disable-next-line no-console
      console.groupEnd();
    }
    window.analytics.track(
      this.eventNameValue,
      {
        url: window.location.href,
        search: window.location.search,
        path: window.location.pathname,
        title: document.title,
        ...this.properties,
      },
    );
  }
}
